import { EnumSchema } from '../metadata-schema';

export const EinduitstroomVSOStatus: EnumSchema = {
	"type": "string",
	"title": "EinduitstroomVSOStatus",
	"enum": [
		"Informatie volledig",
		"Geen behaald uitstroomniveau geregistreerd bij uitschrijving",
		"Ongeldig behaald uitstroomniveau geregistreerd bij uitschrijving",
		"Niet uitgeschreven",
		"Geen einduitstroom"
	]
};
